import React from "react";
import { generateAlphaLink } from "./libs/alphaLinkGen";
import trackEvent from "./libs/trackEvent";

function BotCard({ bot, settings, isValid }) {
  const { name, author, image, id, fileKey, scenarios, tags } = bot;

  const downloadLink = `https://bot-files.miku.gg/${fileKey}`;

  return (
    <a
      className="bot-card_anchor"
      href={generateAlphaLink(id)}
      target="_blank"
      rel="noreferrer"
      onClick={(event) => {
        trackEvent("bot_selected", { bot: name });
        if (!isValid) {
          event.preventDefault();
          alert(
            `Please enter a valid ${
              settings.selectedEndpoint === "openai"
                ? "OpenAI Key"
                : "text-generation-webui API endpoint"
            } first.`
          );
        }
      }}
    >
      <div className="bot-card">
        <div
          className="bot-card-image"
          style={{ backgroundImage: `url(${image})` }}
        />
        <h3>{name}</h3>
        {/* <p>{description}</p> */}
        {/* <p className="bot-card-tags">{tags.map((tag, index) => (
          <span className="bot-card-tag" key={`${fileKey}-${tag}-${index}`}>{tag}</span>
        ))}</p> */}
        {scenarios > 1 ? (
          <span className="bot-card-tag">{scenarios} scenes</span>
        ) : null}
        {tags.includes("nsfw") || tags.includes("NSFW") ? (
          <span className="bot-card-tag-nsfw">NSFW</span>
        ) : null}
        <p>{author}</p>
        <a className="bot-card-download" href={downloadLink} download={fileKey}>
          Download
        </a>
      </div>
    </a>
  );
}

export default BotCard;
